<template>
  <div>
    <h2 class="text-lg font-bold mb-4">Вход</h2>
    <form @submit.prevent="login">
      <input v-model="username" placeholder="Логин" class="border p-2 w-full mb-2" />
      <input v-model="password" type="password" placeholder="Пароль" class="border p-2 w-full mb-4" />
      <button class="bg-blue-500 text-white px-4 py-2 rounded">Войти</button>
    </form>
    <p class="mt-3 text-sm">
      Нет аккаунта? <router-link to="/register">Зарегистрироваться</router-link>
    </p>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'LoginView'
});

import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const username = ref('');
const password = ref('');

const login = async () => {
  const res = await fetch(`${import.meta.env.VITE_API_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username: username.value, password: password.value }),
  });

  if (!res.ok) {
    alert('Неверные данные');
    return;
  }

  const data = await res.json();
  localStorage.setItem('token', data.token);
  router.push('/notes');
};
</script>
